import { makeSx } from '../../theme/_utils'
import { defaultPalette } from '../../theme/idsTheme'

export default makeSx({
    requestersListButton: {
        padding: '0.75rem 1rem',
        borderRadius: '0.5rem',
        gap: '0.75rem',
        display: 'flex',
        background: defaultPalette.typography.main,
        color: defaultPalette.white.main,
        '&:hover': {
            background: defaultPalette.typography.hover,
        },
        '& svg': {
            width: '1.5rem',
            height: '1.5rem',
        },
        '& .MuiTypography-root': {
            display: {
                xs: 'none',
                sm: 'flex',
            },
            fontWeight: 'bold',
            fontSize: '1rem',
            lineHeight: '1.5rem',
        },
    },
    requestersTableActionButtonDanger: {
        color: defaultPalette.error.main,
    },
    requestersTableActionButtonEdit: {
        color: defaultPalette.primary.main,
        textDecoration: 'underline',
    },
    requestersTableText: {
        color: defaultPalette.typography.grey,
        textAlign: 'center',
        fontWeight: 600,
        fontSize: '1rem',
        lineHeight: '1.5rem',
        letterSpacing: '0.15px',
    },
    requestersTableEmptyStateBox: {
        maxWidth: '33rem',
        margin: '0 auto',
        paddingY: '3rem',
    },
    requesterFormContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: '1rem',
        width: '100%',
    },
    requesterForm: {
        width: '100%',
        height: '100%',
        background: '#ffffff',
        borderRadius: '16px',
        overflow: 'hidden',
        boxShadow: '0px 1px 18px rgba(221,225,236,0.6)',
        padding: {
            xs: '1.5rem',
            md: '3.5rem',
        },
    },
    formGroup: {
        width: '100%',
    },
    formGroupInner: {
        width: '100%',
    },
    tooltipContainer: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: '1rem',
        '& .MuiTypography-root': {
            fontSize: '1rem',
        },
    },
    requesterFormDisclaimer: {
        borderLeft: `2px solid ${defaultPalette.orangeWarning.main}`,
        display: 'flex',
        alignItems: 'stretch',
    },
    requesterFormDisclaimerLeft: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        padding: '0 1.6rem 0 .6rem',
    },
    requesterFormDisclaimerIcon: {
        width: '1.5rem',
        height: '1.5rem',
        fill: defaultPalette.orangeWarning.main,
    },
    requesterFormDisclaimerTitle: {
        fontSize: '1.1rem',
        fontWeight: '800',
        color: defaultPalette.orangeWarning.main,
        marginBottom: '.4rem',
    },
    requesterFormDisclaimerContents: {
        display: 'flex',
        flexDirection: 'column',
        gap: '.6rem',
    },
    requesterFormDisclaimerContent: {
        borderBottom: `1px solid ${defaultPalette.lightGrey.half}`,
        '&:last-of-type': {
            borderBottom: 'none',
        },
        paddingBottom: '.6rem',
        '& a': {
            color: defaultPalette.orangeWarning.main,
            textDecoration: 'underline',
            '&:hover': {
                textDecoration: 'none',
            },
        },
    },
    requesterFormDisclaimerButton: {
        padding: '.4rem',
        borderRadius: '.5rem',
        color: defaultPalette.orangeWarning.main,
        textDecoration: 'underline',
    },
})
